import { z } from 'zod';

export const userRoleSchema = z.enum(['admin', 'user']);
export const userLanguageSchema = z.enum(['th', 'en']);

export const loginInputSchema = z.object({
  email: z.string().email('Invalid email format'),
  password: z.string().min(1, 'Password is required'),
});

export const createUserInputSchema = z.object({
  email: z.string().email('Invalid email format').transform(v => v.toLowerCase()),
  password: z.string()
    .min(12, 'Password must be at least 12 characters')
    .regex(/[a-z]/, 'Password must contain lowercase letter')
    .regex(/[A-Z]/, 'Password must contain uppercase letter')
    .regex(/[0-9]/, 'Password must contain a number')
    .regex(/[^a-zA-Z0-9]/, 'Password must contain a special character'),
  role: userRoleSchema.default('user'),
  languagePreference: userLanguageSchema.default('en'),
});

export const updateUserInputSchema = z.object({
  email: z.string().email().transform(v => v.toLowerCase()).optional(),
  password: z.string().min(12).optional(),
  role: userRoleSchema.optional(),
  languagePreference: userLanguageSchema.optional(),
});
